export default "__VITE_ASSET__8269c7c7__"